import React, { useEffect, useRef, useState, useContext } from "react";
import ReactDOMServer from 'react-dom/server';
import { makeStyles } from "@mui/styles";
import { Rnd } from "react-rnd";
import { Theme, useTheme } from "@mui/material/styles";
import { MapContainer, Marker, Popup, TileLayer, Tooltip, useMap } from "react-leaflet";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import mapIcon from "../../assets/img/veding.jpg";
import mapIconS from "../../assets/img/veding.svg";
import mapIconGroup from "../../assets/img/group.svg";
import { getPlanningList } from "../../utils/GetPlanning";
import confirmimg from "../../assets/img/confirm.svg";
import proposedimg from "../../assets/img/proposed.svg";
import scheduledimg from "../../assets/img/scheduled-new.svg";
import overdueimg from "../../assets/img/overdue.svg";
import futureimg from "../../assets/img/future.svg";
import otherdaysimg from "../../assets/img/otherdays.svg";
import warehouseicon from "../../assets/img/warehouseico.png";
import marker from "../../assets/img/map-marker.svg";
import { useLocalStorage } from "../../utils/LocalStorageHook";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CircularLoadButton, { LoadingStatus } from "../../components/LoadingButton";
import NotificationImportantIcon from "@mui/icons-material/NotificationImportant";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import L from "leaflet";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Checkbox, ListItemText, OutlinedInput,CircularProgress,Backdrop, ListItemSecondaryAction } from "@mui/material";
import { DisplayRoleContext } from "../../Context_api";
import RouteList from "./RouteList";
import { PlanningItem } from ".";


interface Inputs {
  data: any;
  //open: any;
  onClose: any;
  onSelect: any;
  planningDate: any;
  warehouseLoc:any
}

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

const useStyles = makeStyles((theme: Theme) => ({
  table: {},
  chipActual: {
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  chipEFDisplay: {
    marginTop: -theme.spacing(1),
    marginRight: theme.spacing(1),
    marginBottom: -theme.spacing(1),
  },
  mapContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

export default function PlanningMapView(props: Inputs) {
  const theme = useTheme();
  const {isDisplayOnlyRole}:any = useContext(DisplayRoleContext);
  const [backup, setBackup] = useState<any>([]);
  const [arr, setState] = useState<any>([]);
  const [map, setMap] = useState<any>();
  const [planningofDate, setPlanningDate] = useState<any>();
  const [updated, setUpdated] = useState<boolean>(false);
  const popupElRef = useRef(null);
  const RndRef = useRef(null);
  const [size, setSize] = useState<any>({x:0,y:0});
  let mapRef = useRef();
const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
const [routesList, setRoutesList] = useState<any[]>([]);
const [checkedCount, setCheckedCount] = useState<number>(0);
const [backdropLoader, setBackdropLoader] = React.useState<boolean>(false);
const [state, setStateData] = useState<any>({ ...props.data });
const [open, setOpen] = React.useState<boolean>(false);


  useEffect(() => {
   // console.log('PROPERTY',props);
    setPlanningDate(props.planningDate.toISOString().split("T")[0]);
    //sameCoordinates(props.data);
    setStateData({ ...props.data });
    setBackup(props.data ? props.data.planningData : []);
    
    if (props.data && props.data.planningData) {
      ScheduledFilter(props.data.planningData, map);
    }
    let routesData = [];
    if(props.data.filteredRoutes){
      for(let i=0; i<props.data.filteredRoutes.length; i++){
        routesData.push(props.data.filteredRoutes[i].route);
      }
     setRoutesList(routesData);
    }
    setRouteName([props.data.selectedRoute]);
   // console.log('RoutesList',routesList);
  }, [props.data, props.planningDate]);


// const warehouseCordinates = ()=> {
//       state.warehouseData = v.l
// }

const handleClose = () => setOpen(false);

  const handleOpen = () => setOpen(true);

  const iconmarker = new L.DivIcon({
    iconAnchor: [12, 25],
    popupAnchor: [0, -15],
    iconSize: [25, 41],
    html: ReactDOMServer.renderToString(<div> </div>),
  });

  const warehouse = new L.DivIcon({
    iconAnchor: [12, 25],
    popupAnchor: [0, -15],
    //iconSize: new L.Point(30, 50),
    iconSize: [50, 90],
    className: 'leaflet-div-icon1',
    html: ReactDOMServer.renderToString(<div><img style={{width:'100%'}} src={warehouseicon} /></div>),
  });

  const warehouseData = state.warehouseData;
  //console.log('warehouseDataaaa:', warehouseData);
  
  // const iconmarker = new L.Icon({
  //   iconUrl: marker,
  //   iconSize: new L.Point(0, 0),
  //   className: "markericon",
  // });
  // const iconP = new L.Icon({
  //   iconUrl: mapIconS,
  //   iconSize: new L.Point(30, 50),
  //   className: "leaflet-div-icon",
  // });
  // const iconS = new L.Icon({
  //   iconUrl: mapIcon,
  //   iconSize: new L.Point(30, 50),
  //   className: "leaflet-div-icon",
  // });

  // const iconGropup = new L.Icon({
  //   iconUrl: mapIconGroup,
  //   iconSize: new L.Point(30, 50),
  //   className: "leaflet-div-icon",
  // });


  // const iconConfirm = new L.Icon({
  //   iconUrl: confirm,
  //   iconSize: new L.Point(30, 50),
  //   className: "leaflet-div-icon",
  // });

  // const iconProposed = new L.Icon({
  //   iconUrl: proposed,
  //   iconSize: new L.Point(30, 50),
  //   className: "leaflet-div-icon",
  // });

  // const iconscheduled= new L.Icon({
  //   iconUrl: scheduled,
  //   iconSize: new L.Point(30, 50),
  //   className: "leaflet-div-icon",
  // });
  
  // const iconsoverdue= new L.Icon({
  //   iconUrl: overdue,
  //   iconSize: new L.Point(30, 50),
  //   className: "leaflet-div-icon",
  // });
  
  // const iconfuture= new L.Icon({
  //   iconUrl: future,
  //   iconSize: new L.Point(30, 50),
  //   className: "leaflet-div-icon",
  // });
  // const iconotherdays= new L.Icon({
  //   iconUrl: otherdays,
  //   iconSize: new L.Point(30, 50),
  //   className: "leaflet-div-icon",
  // });
  
  
  const [centerCoordinates, setCoordinates] = useState<any>([31.305386, -89.289869]);
  let arrlist: any = [];

  const sameCoordinates = (item: any) => {
    
    if (item) {
      let result = item.reduce(function (r: any, a: any) {
        r[a.latitude + "," + a.longitude] = r[a.latitude + "," + a.longitude] || [];
        r[a.latitude + "," + a.longitude].push(a);
        return r;
      }, Object.create(null));
      for (let i = 0; i < Object.keys(result).length; i++) {
        let keys = Object.keys(result)[i].split(",");
        let values: any = Object.values(result)[i];
if(keys &&values ){


        arrlist.push({
          keys: keys,
          values: values.map((item: any) => {
            return { ...item };
          }),
        });

        setState(arrlist);
      }
      }
      if (arrlist.length) {
        //console.log("CHECKarrList", arrlist);
        if (map) {
          if(arrlist.length>0){

            if(arrlist.length==0){
              if(arrlist[0].keys[0]!="" && arrlist[0].keys[1]!=""  ){
                map.setView(arrlist[0].keys, map.getZoom());
                setCoordinates(arrlist[0].keys);
              }
             
            }
            else if(arrlist.length==1){
              if(arrlist[0].keys[0]!="" && arrlist[0].keys[1]!=""  ){
                map.setView(arrlist[0].keys, map.getZoom());
                setCoordinates(arrlist[0].keys);
              }
            }
            else{
              map.setView(arrlist[1].keys, map.getZoom());
              setCoordinates(arrlist[1].keys);
            }
           
            
          }
        
         
        }
      }
    }
  };

  const selectPointer = (obj: any) => {
    props.onSelect(obj);
  };
  const style = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "solid 1px #ddd",
    height: 500,
    paddingTop: "30px",
    backgroundColor: theme.palette.mode=='dark'?"#fff":"#000",
    top: "5em",
  };

  const [filterName, setFilterName] = React.useState<string[]>([]);
  const [routeName, setRouteName] = React.useState<string[]>([]);
  const names = ["Scheduled", "Overdue", "Future", "Scheduled ( Other Days ) ", "Confirm  ( Scheduled )"];
  const handleChange = (event: any) => {
    const {
      target: { value },
    } = event;
    setFilterName(typeof value === "string" ? value.split(",") : value);

    mapFilter(event.target.value);
  };
  const filteredRoutedata:any = [];

  const handleChange1 = (event: any) => {
   //console.log('event: ', event);
    const {
      target: { value },
    } = event;
    setRouteName(typeof value === "string" ? value.split(",") : value);
    if(event.target.value.length > checkedCount){
    let lastElement = event.target.value[event.target.value.length - 1];
    setBackdropLoader(true);
    handleClose();
    getPlanningList(salesOrg.toString(), props.data.selectedDeliveryPlant,lastElement,planningofDate).then(
      (v: any) => {
        //filteredRoutedata.push(v.planning);
        handleOpen();
        let concatatedVal = state.planningData.concat(v?.planning);
        state.planningData = setCurrentStatus(concatatedVal);
        setBackup(state.planningData);  
        
        setBackdropLoader(false);
    }).then(() => {
      mapFilter(filterName);
    });
    setCheckedCount(event.target.value.length);
   }
   else{
    let routelist = []
     if(state.planningData){
      for(let j=0; j<state.planningData.length;j++){
        routelist.push(state.planningData[j].routeAct);
      }
     }
     var array3 = routelist.filter(function(obj) { return event.target.value.indexOf(obj) == -1; });
     let backupUpdated = [];
     for(let k=0; k<state.planningData.length;k++){
      if(state.planningData[k].routeAct != array3[0]){
        backupUpdated.push(state.planningData[k]);
      }
    }
      state.planningData = setCurrentStatus(backupUpdated);
      setBackup(state.planningData);
      mapFilter(filterName);
      setCheckedCount(event.target.value.length);
      //ScheduledFilter(backup, map);
   }
  };

 // console.log('LENGTH: ',checkedCount);
  //console.log('checkbackup', state.planningData.length);

  



  function setCurrentStatus(data:any[]){
    data.map((item) => {
       const nextDelAct = item?.nextDeliveryAct ? 
       new Date(Date.parse(item?.nextDeliveryAct))?.toISOString()?.split("T")[0] : '';
       let scheduledDates = [];
        for (let j=0; j<item.sheduled.length; j++){
          scheduledDates.push(item.sheduled[j].visit_dt_plan);
        }
        const closestDate = getPreviousSheduledList(scheduledDates,planningofDate);
        const currentPlDate:any = new Date(planningofDate);
        let clstDate:any = new Date(closestDate);
        let clstDateDiff = Math.ceil(Math.abs(clstDate - currentPlDate)/(1000 * 60 * 60 * 24));
        const lastDelDate:any = new Date(item.lastDelivery);
        let lastDeliverydiff = Math.ceil(Math.abs(lastDelDate - currentPlDate)/(1000 * 60 * 60 * 24));
        
        //item.currentStatus = "O"

        if (nextDelAct > planningofDate && item.dri >= 0) {
         item.currentStatus = "F"
        }

        if(item?.sheduled?.length == 0 && new Date(item?.nextDeliveryAct) > new Date(planningofDate) && item?.dri < 0) {
          item.currentStatus = 'O';
         }

         if (item.nextDeliveryAct <= planningofDate) {
           if(item.status === 'P'){
            item.currentStatus = 'O';
           }

           if(item.status === 'S'){
             item.currentStatus = 'S';
           }
          }
        
        if(lastDeliverydiff > 60  && clstDateDiff > 60){
         item.currentStatus = "O";
        }

        if(item.sheduled.length > 0 && new Date(item.nextDeliveryAct) > new Date(planningofDate)) {
         item.currentStatus = 'S';
        }

        if (item.status == 'S') {
         item.currentStatus = 'S';
        }

        if(item.status == 'C') {
         item.currentStatus = 'C';
        }
      });

    return data;
  }

  function getPreviousSheduledList (dates:any,target:any){
    let prevDate='1000-01-01';
     if(dates?.length==0){
       return prevDate
     }
     for (let i = 0; i < dates?.length; i++) {
       let dateItems = dates[i];
     if(new Date(dateItems)<new Date(target)){
       if(new Date(prevDate)<new Date(dateItems)){
         prevDate=dateItems;
       }
     }
   }
    return  new Date(prevDate).toISOString().split('T')[0];
   }

  const mapFilter = (array: any) => {
   // console.log('ACTUALBACKUP', state.planningData);
    let filterData = [];
    if (!array.length) {
      sameCoordinates(state.planningData);
      return;
    }

    for (let index = 0; index < array.length; index++) {
      const element = array[index];

      if(state.planningData.length === 0){
        setCoordinates([31.305386, -89.289869])
        setState([]);
      }

      setCoordinates([31.305386, -89.289869])
            setState([]);

      if (element === "Scheduled") {
        if (state.planningData.length > 0) {
          let filterItems = state.planningData.filter((item: any) => {
            let SchedulednextDelAct = new Date(Date.parse(item.nextDeliveryAct)).toISOString().split("T")[0];
            return item.status === "S" && 
            SchedulednextDelAct=== props.planningDate.toISOString().split("T")[0];
          });
          if (filterItems.length) {
            filterData.push(...filterItems);
          } else {
            // arrlist.push({
            //   keys: ["", ""],
            //   values: [],
            // });
           let earr=[{
              keys: ["", ""],
              values: [],
            }];
            setCoordinates([31.305386, -89.289869])
            setState([]);
          }
        }
      } 
      else if (element === "Proposed") {
       // console.log("run Proposed ");
        if (state.planningData.length > 0) {
          let Proposed = state.planningData.filter((item: any) => {
            //item.nextDeliveryAct === planningDate 
            return  item.status === "P" && item.nextDeliveryAct ===props.planningDate.toISOString().split("T")[0]
          });

         // console.log("run Proposed ");
          if (Proposed.length) {
            filterData.push(...Proposed);
          } else {
            // arrlist.push({
            //   keys: ["", ""],
            //   values: [],
            // });
            let earr=[{
              keys: ["", ""],
              values: [],
            }];
            setCoordinates([31.305386, -89.289869])
            setState([]);
          }
        }
      } else if (element === "Overdue") {
       // console.log("run Overdue ");
        if (state.planningData.length > 0) {
          let filterItems = state.planningData.filter((item: any) => {
            return (
             item.currentStatus == "O"
             );
          });

          if (filterItems.length) {
            filterData.push(...filterItems);
          } else {
            // arrlist.push({
            //   keys: ["", ""],
            //   values: [],
            // });
            let earr=[{
              keys: ["", ""],
              values: [],
            }];
            setCoordinates([31.305386, -89.289869])
            setState([]);
          }
        }
      } else if (element === "Future") {
        //console.log("run Future item.nextDeliveryAct === planningDate ");
        if (state.planningData.length > 0) {
          let filterItems = state.planningData.filter((item: any) => {
            return item.currentStatus == 'F'
          });
          if (filterItems.length) {
            filterData.push(...filterItems);
          } else {
            // arrlist.push({
            //   keys: ["", ""],
            //   values: [],
            // });
            let earr=[{
              keys: ["", ""],
              values: [],
            }];
            setCoordinates([31.305386, -89.289869])
            setState([]);
          }
        }
      } else if (element === "Scheduled ( Other Days ) ") {
       // console.log("run Scheduled Other Days ");
        if (state.planningData.length > 0) {
          let otherday = state.planningData.filter((item: any) => {
            const nextDelActOther = new Date(Date.parse(item.nextDeliveryAct)).toISOString().split("T")[0];
            return (
             nextDelActOther != props.planningDate.toISOString().split("T")[0] &&
              item.status == "S" 
              
            );
          })

          if (otherday.length) {
            filterData.push(...otherday);
          } else {
            // arrlist.push({
            //   keys: ["", ""],
            //   values: [],
            // });
            let earr=[{
              keys: ["", ""],
              values: [],
            }];
            setCoordinates([31.305386, -89.289869])
            setState([]);
          }
        }
      } else if (element === "Confirm  ( Scheduled )") {
        //console.log("Confirm");
        if (state.planningData.length > 0) {
          let filterItems = state.planningData.filter((item: any) => {
        
            return item.status === "C";
          });

          if (filterItems.length) {
            filterData.push(...filterItems);
          } else {
            // arrlist.push({
            //   keys: ["", ""],
            //   values: [],
            // });
            let earr=[{
              keys: ["", ""],
              values: [],
            }];
            setCoordinates([31.305386, -89.289869])
            setState([]);
          }
        }
      }
    }
    if (filterData.length) {
      let dup = [...new Set(filterData)];
      sameCoordinates(dup);
    }
  };

  const ScheduledFilter = (backup: any, map: any) => {
   // console.log('checkFiltername:', filterName);
    if (filterName.length == 0) {
      let filterItems = backup.filter((item: any) => {
        return item.status === "S" && item.nextDeliveryAct === props.planningDate.toISOString().split("T")[0];
      });
      setFilterName(["Scheduled"]);
      sameCoordinates(filterItems);
      
    }
    
    
  };

  //console.log('checkFilternameAct:', filterName);
  
  const initmap = (e: any) => {
    setMap(e);
    if(arr.length>0){
      e.setView(arr[0].keys, e.getZoom());
    }

    if(props.warehouseLoc.length > 0){
      e.setView([props.warehouseLoc[0].latitude,props.warehouseLoc[0].longitude]);
      setCoordinates([props.warehouseLoc[0].latitude,props.warehouseLoc[0].longitude]);
    }
    
  };

  // const customMarkerIcon = new L.DivIcon({
  //   iconAnchor: [12, 25],
  //   popupAnchor: [0, -15],
  //   iconSize: [25, 41],
  //   html: ReactDOMServer.renderToString(<div> <span className="marker-count"> 30</span><img style={{width:'100%'}} src={confirm} /></div>),
  // });

  const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

  return (
    <>
      <Backdrop sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 1 }} open={backdropLoader}>
        <CircularProgress color="primary" />
      </Backdrop>
      <Rnd
          ref={RndRef}
        dragHandleClassName="dragHeader"
        style={style}
        enableResizing={{
          top:false,
  topLeft:false,
  topRight:false,
  bottom:true,
  bottomLeft:true,
  bottomRight:true,
  left:true,
  right:true
        }

        }
        //size={{ width: 200,  height: 300 }}
  //position={{ x: 10, y: 10 }}
        //position={{ x: size.x, y: size.y }}
        default={{
          x: size.x,
          y: size.y,
          width: (window.innerWidth-100),
          height: (window.innerHeight-200),
        }}
        onResize={(e, direction, ref, delta, position) => {
        
          map._onResize();
        }}
        minWidth={300}
        minHeight={190}
        bounds="window"
        disableDragging={false}
      
        
        // style={{ height: 500, padding: "20px", backgroundColor: "#fff", border: "1px solid #ccc" }}
      >
        <div
          className="dragHeader"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            width: "100%",
            background: theme.palette.mode=='dark'?"#000":"#fff",
            zIndex: 9999,
            cursor: "move",
            height: "49px",
            padding: "12px",
            fontWeight: 600,
          }}
        >
          Map View
          <IconButton
            onClick={props.onClose}
            style={{
              float: "right",
              zIndex: 100,
              position: "absolute",
              top: "-1px",
              right: "0px",
              backgroundColor: theme.palette.mode=='dark'?"#000":"#fff",
            }}
          >
            <CloseIcon />
          </IconButton>

          <Select
            labelId="demo-multiple-checkbox-label"
            style={{ float: "right", right: "42px", top: "-12px", height: "49px", width: "161px" }}
            multiple
            displayEmpty
            value={filterName}
            onChange={handleChange}
            input={<OutlinedInput value="filter" label="Tag" />}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return "Filter";
              }

              return "Filter";
            }}
          >
            {names.map((name) => (
              <MenuItem id="mapfilter" key={name} value={name}>
                <Checkbox checked={filterName.indexOf(name) > -1} />
                <ListItemText className={name.replace(/[()]/g, "")} primary={name} />
              </MenuItem>
            ))}
          </Select>
          
          <Select
          labelId="demo-multiple-checkbox-label1"
          id="demo-multiple-checkbox1"
          style={{ float: "right", right: "60px", top: "-12px", height: "49px", width: "161px" }}
          multiple
          open={open}
          onClose={handleClose}
          onOpen={handleOpen}
          value={routeName}
          onChange={handleChange1}
          input={<OutlinedInput label="Tag" />}
          renderValue={(selected) => selected.join(', ')}
        >
          {routesList.map((route) => (
            <MenuItem key={route} value={route}>
              <Checkbox checked={routeName.indexOf(route) > -1} />
              <ListItemText primary={route} />
            </MenuItem>
          ))}

        </Select>
          
        </div>

        <MapContainer
          //ref={mapRef}
          whenCreated={(e) => {
            initmap(e);
          }}
          doubleClickZoom={false}
          center={centerCoordinates}
          zoom={8}
          style={{ width: "100%", height: "calc(100% - 38px)", margin: "0 auto" }}
        >
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

        {props.warehouseLoc?.map((item: any, index: any) => {
           // console.log('PROPSPLANT',props.data.plants);
          let warehouseName = props.data.plants.filter((wh:any) => wh.plant === item.plant);
           return(<Marker  position={[item.latitude, item.longitude]} icon={warehouse}>
            <Tooltip>
                  { 
                    <span style={{ fontSize: 14 }}>
                      Plant - <span style={{ fontWeight: 600 }}>{warehouseName[0]?.name}</span>
                    </span>
                  }
                </Tooltip>
           </Marker>
           )
           
          })}

          {arr.map((item: any, index: any) => {
            let iconstates=iconmarker;

            
            let scheduled = item.values.filter((list: any) => {
              return list.status === "S" && list.nextDeliveryAct === props.planningDate.toISOString().split("T")[0];
            });

            let proposed = item.values.filter((list: any) => {
              return list.status === "P" && list.nextDeliveryAct ===props.planningDate.toISOString().split("T")[0]
            });

            let confirm = item.values.filter((list: any) => {
              return list.status == "C";
            });

            let overdue = item.values.filter((list: any) => {
              return (
                list.currentStatus == 'O'
              );
            });

            let future = item.values.filter((list: any) => {
              return (
               list.currentStatus == 'F'
              );
            });

            let otherdays = item.values.filter((list: any) => {
              const nextDelAct = new Date(Date.parse(list.nextDeliveryAct)).toISOString().split("T")[0];
              return (
                // nextDelAct >= props.planningDate.toISOString().split("T")[0] &&
                // nextDelAct != props.planningDate.toISOString().split("T")[0]  &&
                // list.dri != 0 
                list.status === "S"
              );
            });

            
            

            if (overdue.length >= 1) {
              //iconstates = iconsoverdue;
              iconstates = new L.DivIcon({
                iconAnchor: [12, 25],
                popupAnchor: [0, -15],
                iconSize: [25, 41],
                html: ReactDOMServer.renderToString(<div>{overdue.length>1?<span className="marker-count">{overdue.length}</span>:''}<img style={{width:'100%'}} src={overdueimg} /><div style={{marginTop:'-7px', backgroundColor:'#ffffff'}}><b>{item.values[0].routeAct}</b></div></div>),
              });
            }
            
            if(confirm.length >= 1){
              //iconstates = iconConfirm;
              iconstates = new L.DivIcon({
                iconAnchor: [12, 25],
                popupAnchor: [0, -15],
                iconSize: [25, 41],
                html: ReactDOMServer.renderToString(<div>  {confirm.length>1?<span className="marker-count">{confirm.length}</span>:''}<img style={{width:'100%'}} src={confirmimg} /><div style={{marginTop:'-7px', backgroundColor:'#ffffff'}}><b>{item.values[0].routeAct}</b></div></div>),
              });
            }
           

            if(proposed.length >= 1){
              //iconstates = iconProposed;
              iconstates = new L.DivIcon({
                iconAnchor: [12, 25],
                popupAnchor: [0, -15],
                iconSize: [25, 41],
                html: ReactDOMServer.renderToString(<div>  {proposed.length>1?<span className="marker-count">{proposed.length}</span>:''}<img style={{width:'100%'}} src={proposedimg} /><div style={{marginTop:'-7px', backgroundColor:'#ffffff'}}><b>{item.values[0].routeAct}</b></div></div>),
              });
            }

            

            if(future.length >= 1){
              //iconstates = iconfuture;
              iconstates = new L.DivIcon({
                iconAnchor: [12, 25],
                popupAnchor: [0, -15],
                iconSize: [25, 41],
                html: ReactDOMServer.renderToString(<div>  {future.length>1?<span className="marker-count">{future.length}</span>:''}<img style={{width:'100%'}} src={futureimg} /><div style={{marginTop:'-7px', backgroundColor:'#ffffff'}}><b>{item.values[0].routeAct}</b></div></div>),
              });
            }

            if(otherdays.length >= 1){
              //iconstates = iconotherdays;
              iconstates = new L.DivIcon({
                iconAnchor: [12, 25],
                popupAnchor: [0, -15],
                iconSize: [25, 41],
                html: ReactDOMServer.renderToString(<div>  {otherdays.length>1?<span className="marker-count">{otherdays.length}</span>:''}<img style={{width:'100%'}} src={otherdaysimg} /><div style={{marginTop:'-7px', backgroundColor:'#ffffff'}}><b>{item.values[0].routeAct}</b></div></div>),
              });
            }

            if (scheduled.length >= 1) {
              //iconstates = iconscheduled;
              iconstates = new L.DivIcon({
                iconAnchor: [12, 25],
                popupAnchor: [0, -15],
                iconSize: [25, 41],
                html: ReactDOMServer.renderToString(<div>  {scheduled.length>1?<span className="marker-count">{scheduled.length}</span>:''}<img style={{width:'100%'}} src={scheduledimg} /><div style={{marginTop:'-7px', backgroundColor:'#ffffff'}}><b>{item.values[0].routeAct}</b></div></div>),
              });
            }
          //  console.log('item:: ', item);
            //status.length >= 1 ? iconS : iconP 
            return (
              <Marker  position={[item.keys[0], item.keys[1]]}   icon={iconstates} >
                
                <Popup minWidth={400} ref={popupElRef}>
                  <ul className="mappop" style={{ margin: "0px", padding: "0px", height: 400, overflowY: "scroll" }}>
                    {item.values.map((e: any) => (
                      <li
                        style={{
                          listStyleType: "none",

                          padding: "10px 0px",
                          borderBottom: "1px solid #ebe1e1",
                        }}
                      >
                         <CircularLoadButton
                          id={1}
                          settingsKey="VS_PLN"
                          style={{ padding: "2px" }}
                          title=""
                          disabled={(isDisplayOnlyRole && e.status == "P"  && !e?.review)}
                          icon={
                            e.currentStatus === 'O' ? (<NotificationImportantIcon />): e.currentStatus === 'F' ? (<AccessTimeIcon />) :
                            e.status === "S" && e.nextDeliveryAct === props.planningDate.toISOString().split("T")[0]?(
<LocalShippingIcon />
                            ):e.status === "C"?<DoneOutlineIcon />:
                            new Date(Date.parse(e.nextDeliveryAct)).toISOString().split("T")[0] <= props.planningDate.toISOString().split("T")[0] &&
                e.status != "S" && e.status != "C" &&
                e.nextDeliveryAct != props.planningDate.toISOString().split("T")[0]? <NotificationImportantIcon />:
                e.status === "S" && e.nextDeliveryAct != props.planningDate.toISOString().split("T")[0]?<LocalShippingIcon />:
                new Date(Date.parse(e.nextDeliveryAct)).toISOString().split("T")[0] > props.planningDate.toISOString().split("T")[0] && e.dri >= 0? <AccessTimeIcon color={e.loading ? "disabled" : "inherit"} /> :
                e.status === "P" && e.nextDeliveryAct ===props.planningDate.toISOString().split("T")[0]?<AccessTimeIcon color={e.loading ? "disabled" : "inherit"} />:""
                           
                          }
                          variant={e.nextDeliveryAct === planningofDate ? "contained" : "outlined"}
                          status={e.loading ? LoadingStatus.Loading : LoadingStatus.Initial}
                          loadFn={(el) => selectPointer(e)}
                        /> 
                        <span
                          style={{
                            display: "block",
                            color: "#08af12",
                            fontWeight: 800,
                          }}
                        >
                          {" "}
                          {e.customerNum}{" "}
                        </span>
                        <span> {e.name}, </span>
                        <div>
                          DRI:{" "}
                          <span
                            style={{
                              color: "#0a74ef",
                            }}
                          >
                            {" "}
                            {e.dri}
                          </span>{" "}
                          / PFR:{" "}
                          <span
                            style={{
                              color: "#0a74ef",
                            }}
                          >
                            {" "}
                            {e.pfr}
                          </span>{" "}
                          / PFRC:{" "}
                          <span
                            style={{
                              color: "#0a74ef",
                            }}
                          >
                            {" "}
                            {e.pfrc}{" "}
                          </span>
                          / PFU:{" "}
                          <span
                            style={{
                              color: "#0a74ef",
                            }}
                          >
                            {" "}
                            {e.pfu}
                          </span>
                        </div>
                        {e.nextDeliveryAct}
                        {/* <div> {e.status}    {e.nextDeliveryAct} ---{planningofDate}</div> */}
                      </li>
                    ))}
                  </ul>
                </Popup>
               
                <Tooltip>
                  { 
                   
                    <span style={{ fontSize: 14 }}>
                      Route: <span style={{ fontWeight: 600 }}>{item?.values[0]?.routeAct}{" "}</span>,
                      <span style={{ fontWeight: 600 }}> {item.values.length}</span> Vending Machines ,
                      <span>
                        {" "}
                        Scheduled <span style={{ fontWeight: 600 }}>{scheduled.length}</span>
                      </span>
                      <span>
                        {" "}
                        Overdue <span style={{ fontWeight: 600 }}>{overdue.length}</span>
                      </span>
                      <span>
                        {" "}
                        Confirm <span style={{ fontWeight: 600 }}>{confirm.length}</span>
                      </span>
                    </span>
                    
                  }
                </Tooltip>
                
              </Marker>
            );
          })}
        </MapContainer>
      </Rnd>
    </>
  );
}
